import { useEffect } from 'react';

const useBrevoEvent = (isAuthenticated, user) => {
    const getCartData = () => {
        // Obtener el carrito actual del localStorage
        const cartItems = JSON.parse(localStorage.getItem('products_cart') || '[]');
        
        // Calcular totales
        const subtotal = cartItems.reduce((acc, item) => {
            const price = isAuthenticated && item.sale_price ? item.sale_price : item.price;
            return acc + (price * item.quantity);
        }, 0);

        return {
            cartItems,
            subtotal
        };
    };

    const sendCartUpdatedEvent = async () => {
        if (!isAuthenticated || !user?.email) return;

        try {
            const { cartItems, subtotal } = getCartData();

            const brevoEvent = {
                event_name: "cart_updated",
                identifiers: {
                    email_id: user.email
                },
                contact_properties: {
                    email: user.email
                },
                event_properties: {
                    affiliation: "Donde La Negra",
                    checkouturl: "https://dondelanegra.cl/checkout/",
                    currency: "CLP",
                    discount: 0,
                    items: cartItems.map(item => ({
                        category: item.categories?.[0]?.name || "Sin categoría",
                        id: item.wordpress_id,
                        image: item.image,
                        name: item.name,
                        price: isAuthenticated && item.sale_price ? item.sale_price : item.price,
                        quantity: item.quantity,
                        sku: item.sku,
                        url: `https://dondelanegra.cl/producto/${item.slug}/`
                    })),
                    subtotal: subtotal,
                    total: subtotal,
                    total_before_tax: subtotal,
                    url: "https://dondelanegra.cl/endCart/"
                }
            };

            await fetch(`${process.env.BASE_URL}/brevo/events`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(brevoEvent)
            });
        } catch (error) {
            console.error("Error al enviar evento cart_updated a Brevo:", error);
        }
    };

    const sendCartDeletedEvent = async (deletedItem) => {
        if (!isAuthenticated || !user?.email) return;

        try {
            const { cartItems, subtotal } = getCartData();

            const brevoEvent = {
                event_name: "cart_deleted",
                identifiers: {
                    email_id: user.email
                },
                contact_properties: {
                    email: user.email
                },
                event_properties: {
                    affiliation: "Donde La Negra",
                    checkouturl: "https://dondelanegra.cl/checkout/",
                    currency: "CLP",
                    discount: 0,
                    deleted_item: {
                        category: deletedItem.categories?.[0]?.name || "Sin categoría",
                        id: deletedItem.wordpress_id,
                        image: deletedItem.image,
                        name: deletedItem.name,
                        price: isAuthenticated && deletedItem.sale_price ? deletedItem.sale_price : deletedItem.price,
                        quantity: deletedItem.quantity,
                        sku: deletedItem.sku,
                        url: `https://dondelanegra.cl/producto/${deletedItem.slug}/`
                    },
                    remaining_items: cartItems.map(item => ({
                        category: item.categories?.[0]?.name || "Sin categoría",
                        id: item.wordpress_id,
                        image: item.image,
                        name: item.name,
                        price: isAuthenticated && item.sale_price ? item.sale_price : item.price,
                        quantity: item.quantity,
                        sku: item.sku,
                        url: `https://dondelanegra.cl/producto/${item.slug}/`
                    })),
                    subtotal: subtotal,
                    total: subtotal,
                    total_before_tax: subtotal,
                    url: "https://dondelanegra.cl/endCart/"
                }
            };

            await fetch(`${process.env.BASE_URL}/brevo/events`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(brevoEvent)
            });
        } catch (error) {
            console.error("Error al enviar evento cart_deleted a Brevo:", error);
        }
    };

    return { 
        sendCartUpdatedEvent,
        sendCartDeletedEvent
    };
};

export default useBrevoEvent; 